// App中的webview生命周期

/**
 * webview生命周期, 当webview准备好时触发
 * @param {Function} callback 回调函数
 * @example import { webviewOnReady } from "@ht/utils";
 * webviewOnReady(() => {
 *  console.log("webview ready"); dd
 * })
 */
export const webviewOnReady = (callback: () => void) => {
  window.onReady = () => {
    callback();
  };
};

/**
 * webview生命周期, 当webview显示时触发
 * @param {Function} callback 回调函数
 * @example import { webviewOnShow } from "@ht/utils";
 * webviewOnShow(() => {
 *  console.log("webview show");
 * })
 */
export const webviewOnShow = (callback: () => void) => {
  window.onShow = () => {
    callback();
  };
};

/**
 * webview生命周期, 当webview隐藏时触发
 * @param {Function} callback 回调函数
 * @example import { webviewOnHidden } from "@ht/utils";
 * webviewOnHidden(() => {
 *  console.log("webview hidden");
 * })
 */
export const webviewOnHidden = (callback: () => void) => {
  window.onHide = () => {
    callback();
  };
};

/**
 * webview生命周期, 当webview关闭时触发
 * @param {Function} callback 回调函数
 * @example import { webviewOnUnload } from "@ht/utils";
 * webviewOnUnload(() => {
 *   console.log("webview unload");
 * })
 */

export const webviewOnUnload = (callback: () => void) => {
  window.onUnload = () => {
    callback();
  };
};
